var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.00002C11.9999 5.18702 11.643 4.42002 11.0374 3.93802C11.1074 3.12702 10.8174 2.33252 10.2424 1.75702C9.66745 1.18252 8.87495 0.891516 8.10395 0.979516C7.09695 -0.298484 4.92145 -0.322484 3.93795 0.962016C2.32145 0.770016 0.766949 2.29202 0.979949 3.89602C-0.298051 4.90302 -0.322551 7.07852 0.962449 8.06252C0.892449 8.87352 1.18245 9.66802 1.75745 10.2435C2.33245 10.818 3.12595 11.109 3.89595 11.021C4.90295 12.299 7.07845 12.323 8.06195 11.0385C8.87195 11.108 9.66695 10.819 10.2424 10.2435C10.8169 9.66852 11.1069 8.87352 11.0199 8.10502C11.643 7.58102 11.9999 6.81402 11.9999 6.00102V6.00002ZM3.99995 4.50002C4.00295 3.84602 4.99695 3.84602 4.99995 4.50002C4.99695 5.15402 4.00295 5.15402 3.99995 4.50002ZM5.41595 7.77752C5.26195 8.00902 4.94945 8.06802 4.72245 7.91602C4.49245 7.76302 4.43045 7.45252 4.58395 7.22252L6.58395 4.22252C6.73695 3.99302 7.04695 3.93002 7.27745 4.08402C7.50745 4.23702 7.56945 4.54752 7.41595 4.77752L5.41595 7.77752ZM7.49995 8.00002C6.84595 7.99702 6.84595 7.00302 7.49995 7.00002C8.15395 7.00302 8.15395 7.99702 7.49995 8.00002Z",
    fill: "#008080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageBadgeIcon);
export default __webpack_public_path__ + "static/media/percentage-badge-icon.2b5752a6239541375b4ea7910c8e0138.svg";
export { ForwardRef as ReactComponent };